exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".updateProfileContainer[data-v-81574b1a]{min-height:300px;width:100%}.explanation[data-v-81574b1a],.title[data-v-81574b1a]{color:grey;padding:10px;font-family:Roboto,sans-serif}.textInput[data-v-81574b1a]{border:1px solid #add8e6;width:100%;border-radius:5px;padding:10px;margin-top:5px;outline:none}.textarea[data-v-81574b1a]{resize:none}.updateProfileButtons[data-v-81574b1a]{background:#d35b5b;border-radius:5px;color:#fff;font-family:Roboto,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-81574b1a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/_mainDirectives/myprofile/components/breifinfoComponents/addPinnedReads.vue
// module id = 501
// module chunks = 0